module.exports = __webpack_public_path__ + "img/8.a70f317b.jpg";